import {gql} from '@apollo/client';

import {
  VeritasFormatPreviewQuery,
  VeritasFormatPreviewQueryVariables,
} from 'antibodies/format/__generated/VeritasFormatPreviewQuery';
import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

type VeritasFormatPreviewResponse = VeritasFormatPreviewQuery['veritasFormatPreview'];

export const VERITAS_FORMAT_PREVIEW_QUERY = gql`
  query VeritasFormatPreviewQuery($veritasFormatName: StrictString!)
  @skipAudit
  @engComponent(name: ANTIBODIES) {
    veritasFormatPreview(veritasFormatName: $veritasFormatName) {
      ... on VeritasFormatPreviewErrorNode {
        message
      }
      ... on AntibodyFormatNode {
        ...AntibodyFormatGraphQL
      }
    }
  }
  ${getFragmentWrapper('AntibodyFormat').fragment}
`;

export interface UseVeritasFormatPreviewQueryResult {
  status: QueryResultType;
  result: VeritasFormatPreviewResponse | null;
}

export function useVeritasFormatPreviewQuery(
  veritasFormatName: string | null
): UseVeritasFormatPreviewQueryResult {
  const result = useSkippableBenchlingQuery<VeritasFormatPreviewQuery, VeritasFormatPreviewQueryVariables>(
    VERITAS_FORMAT_PREVIEW_QUERY,
    {
      variables: {veritasFormatName: veritasFormatName!},
      skip: veritasFormatName == null || veritasFormatName === '',
      fetchPolicy: 'network-only',
    }
  );

  return {
    status: result.type,
    result: result.type === QueryResultType.SUCCESS ? result.data.veritasFormatPreview : null,
  };
}
